export default __webpack_public_path__ + "static/media/thrilled.01acfe11.svg";